import { render, staticRenderFns } from "./TermosContrato.vue?vue&type=template&id=a7777842&scoped=true&"
import script from "./TermosContrato.vue?vue&type=script&lang=js&"
export * from "./TermosContrato.vue?vue&type=script&lang=js&"
import style0 from "./TermosContrato.vue?vue&type=style&index=0&id=a7777842&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7777842",
  null
  
)

export default component.exports